import React from 'react'
import MyDoctors from '../Components/MyDoctorsComp/MyDoctors'

const MyDoctorsView = () => {
  return (
    <div>
        <MyDoctors />
    </div>
  )
}

export default MyDoctorsView